import * as React from 'react';
import Icon from '../Icon';
import Button from '../Button';

export interface AccordionHeaderProps {
  id: string;
  open: boolean;
  title?: string;
  disabled?: boolean;
  description?: React.ReactNode;
  expandedTitle?: string;
  collapsedTitle?: string;
  onClick: (name: string, isExpanded: boolean) => void;
}

function AccordionHeader(props: AccordionHeaderProps) {
  const {
    id,
    open = false,
    title,
    onClick,
    description,
    disabled = false,
    expandedTitle = 'Expand',
    collapsedTitle = 'Close',
  } = props;

  const handleClick = () => {
    if (!disabled) {
      onClick(id, open);
    }
  };

  return (
    // jsx-a11y/click-events-have-key-events
    <div
      role="button"
      tabIndex={0}
      className="ui-accordion-header"
      aria-disabled={disabled}
      aria-expanded={open}
      aria-controls={`panel${id}-content`}
      id={`panel${id}-header`}
      onClick={handleClick}
    >
      <div className="ui-accordion-header-content">
        {title && <h4 className="ui-accordion-title">{title}</h4>}
        {description && (
          <p className="ui-accordion-description">{description}</p>
        )}
      </div>
      <Button
        className="ui-accordion-button"
        btnStyle="outline"
        size="medium"
        disabled={disabled}
        startIcon={
          open ? (
            <Icon name="chevron-up" size="x-small" />
          ) : (
            <Icon name="chevron-down" size="x-small" />
          )
        }
      >
        {open ? collapsedTitle : expandedTitle}
      </Button>
    </div>
  );
}

export default AccordionHeader;
